import SharedComponentBlockBreadcrumbItem from "./SharedComponentBlockBreadcrumbItem";
import { useSharedComponentBlocks } from "../hooks/useSharedComponentBlocks";
import { useLightningLanderContext } from "features/lightningLanders/providers/LightningLanderProvider";

function SharedComponentBlockBreadcrumb() {
    const { setBlocks } = useSharedComponentBlocks();
    const { component, setComponent } = useLightningLanderContext();

    if (!component) {
        return <></>;
    }

    return (
        <SharedComponentBlockBreadcrumbItem
            component={component}
            setComponent={setComponent}
            setComponents={setBlocks}
        />
    );
}

export default SharedComponentBlockBreadcrumb;

